/** Map ws(s)://host → http(s)://host (no trailing slash). */
function httpOriginFromWsUrl(wsUrl) {
  const u = String(wsUrl || '').trim();
  if (!u) return '';
  return u.replace(/^wss:\/\//i, 'https://').replace(/^ws:\/\//i, 'http://').replace(/\/$/, '');
}

// Runtime config (production): written by entrypoint.sh from Kubernetes env vars.
// Fallback to process.env.REACT_APP_* for local development (npm start / .env file).
function runtimeConfig() {
  return window.APP_CONFIG || {};
}

/**
 * Public HTTP API origin (no trailing slash).
 * When unset, derives from WS_URL if set; otherwise same origin as the SPA.
 */
export function getPublicApiOrigin() {
  const cfg = runtimeConfig();
  const env = cfg.API_URL || process.env.REACT_APP_API_URL;
  if (env != null && String(env).trim() !== '') {
    return String(env).trim().replace(/\/$/, '');
  }
  const wsEnv = cfg.WS_URL || process.env.REACT_APP_WS_URL;
  if (wsEnv != null && String(wsEnv).trim() !== '') {
    const fromWs = httpOriginFromWsUrl(wsEnv);
    if (fromWs) return fromWs;
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
}

/**
 * WebSocket origin (no trailing slash, ws: or wss:).
 * When unset, derives from page origin (http→ws, https→wss).
 */
export function getPublicWsOrigin() {
  const cfg = runtimeConfig();
  const env = cfg.WS_URL || process.env.REACT_APP_WS_URL;
  if (env != null && String(env).trim() !== '') {
    return String(env).trim().replace(/\/$/, '');
  }
  const apiEnv = cfg.API_URL || process.env.REACT_APP_API_URL;
  if (apiEnv != null && String(apiEnv).trim() !== '') {
    const u = String(apiEnv).trim().replace(/\/$/, '');
    return u.replace(/^https:\/\//i, 'wss://').replace(/^http:\/\//i, 'ws://');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/^http/, 'ws');
  }
  return '';
}
